import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { getEvents } from '@/repositories/wpRestApiRepository'
import { EventItem, EventsByHospitalId } from '@/types/Event'

// NOTE: モジュールの実例として分離しましたが、必ずしもモジュール化する必要はありません
// 今回で言えば、homeモジュールにHome画面で使用するイベントの状態をもたせても問題ありません
interface EventsState {
  events: EventItem[]
  eventsByHospitalId: EventsByHospitalId[]
}

const eventsState = {
  events: [],
  eventsByHospitalId: []
}

export const events: Module<EventsState, RootState> = {
  namespaced: true,
  state: eventsState,
  mutations: {
    setEvents(state: EventsState, payload: EventItem[]) {
      state.events = payload
    },
    // 病院詳細（/search/hospital/detail/）で参加イベント取得するため
    // 全イベントを病院idでソート
    setEventsByHospitalIds(state: EventsState, allhospitalIds: string[]) {
      const allEvents = state.events
      const allEventsByHospitalIds = allhospitalIds.map((id) => ({
        hospitalId: id,
        events: allEvents.filter(
          (event) => !!event.hospitalIds && event.hospitalIds.includes(id)
        )
      }))
      state.eventsByHospitalId = allEventsByHospitalIds
    }
  },
  actions: {
    async loadEvents({ commit }, { perPage }) {
      const res = await getEvents({ perPage })
      commit('setEvents', res.data)
    }
  },
  getters: {
    getEvents(state): EventItem[] {
      return state.events
    },
    // 病院（ID）が参加しているイベント情報を返す
    getEventsByHospitalId: (state) => (hospitalId: string): EventItem[] => {
      const targetItem = state.eventsByHospitalId.find(
        (data) => data.hospitalId === hospitalId
      )
      return targetItem?.events || []
    }
  }
}
